import { useEffect, useReducer, useState, useContext } from 'react';

import './DetailsMain.scss';
import { Container, Row, Col } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import arrowLeft from '../../../assets/icons/arrow-ios-left.svg';
import arrowRight from '../../../assets/icons/arrow-ios-right.svg';
import arrowDown from '../../../assets/icons/arrow-ios-down.svg';
import BIDDetailsMail from './DetailsMail/DetailsMail';
import checkmark from '../../../assets/icons/checkmark-circle-fill-blue.svg';
import DetailsPhone from './DetailsPhone/DetailsPhone';
import DetailsPassword from './DetailsPassword/DetailsPassword';
import LoginContext from '../../../store/login-context';
import DetailsApprove from './DetailsApprove/DetailsApprove';

declare var _curLang: any;
declare function Translate(key: string): string;


const detailsStepsReducer = (state,action) => {
  if(action.type === 'UPDATE_MAIL_STEP'){
    return ({mailStepCompletetd: action.value, 
            phoneStepCompletetd: state.phoneStepCompletetd,
            passStepCompletetd: state.passStepCompletetd,
            contactStepCompleted: state.contactStepCompleted});
  }
  if(action.type === 'UPDATE_MOBILE_STEP'){
    return ({mailStepCompletetd: state.mailStepCompletetd, 
            phoneStepCompletetd: action.value,
            passStepCompletetd: state.passStepCompletetd,
            contactStepCompleted: state.contactStepCompleted});
  }
  if(action.type === 'UPDATE_PASSWORD_STEP'){
    return ({mailStepCompletetd: state.mailStepCompletetd, 
            phoneStepCompletetd: state.phoneStepCompletetd,
            passStepCompletetd: action.value,
            contactStepCompleted: state.contactStepCompleted});
  }
  if(action.type === 'UPDATE_CONTACT_STEP'){
    return ({mailStepCompletetd: state.mailStepCompletetd, 
            phoneStepCompletetd: state.phoneStepCompletetd,
            passStepCompletetd: state.passStepCompletetd,
            contactStepCompleted: action.value});
  }
};

const DetailsMain = props => {
  
  const ctx = useContext(LoginContext);
  const [activeKey, setActiveKey] = useState('0');

  const [detailsStepsState, dispatchDetailsSteps] = useReducer(detailsStepsReducer,{
    mailStepCompletetd: !props.neededInfo.includes('email'),
    phoneStepCompletetd: !props.neededInfo.includes('mobile'),
    passStepCompletetd: !props.neededInfo.includes('password'),
    contactStepCompleted: false
  })
  
  useEffect(() => {
    if (props.neededInfo.includes('email')) {
      setActiveKey('0');      
    } else if (
      !props.neededInfo.includes('email') &&
       props.neededInfo.includes('mobile')
    ) {
      setActiveKey('1');  
    } else if (
      !props.neededInfo.includes('email') &&
      !props.neededInfo.includes('mobile') &&
       props.neededInfo.includes('password')
    ) {
      setActiveKey('2');  
    } else if (
      !props.neededInfo.includes('email') &&
      !props.neededInfo.includes('mobile') &&
      !props.neededInfo.includes('password')
    ) {
      setActiveKey('');  
    }
  },[]);

  useEffect(() => {
    if (
      detailsStepsState!.mailStepCompletetd &&
      detailsStepsState!.phoneStepCompletetd &&
      detailsStepsState!.passStepCompletetd &&
      detailsStepsState!.contactStepCompleted
    ){
      console.log("All steps completed");     
      props.detailsCompleted();                         
    }
        
  },[detailsStepsState, props]);

  const handleSelect = (activeKey) => {
    setActiveKey(activeKey);    
  }

  const onMailStepCompleted = () => {    
    dispatchDetailsSteps({type:'UPDATE_MAIL_STEP', value: true});              

    if (props.neededInfo.includes('mobile')) {
      handleSelect('1');
    } else if (props.neededInfo.includes('password')) {
      handleSelect('2');
    } else if (
      !props.neededInfo.includes('mobile') &&
      !props.neededInfo.includes('password')
    ) {
      handleSelect('');
    }
  };

  const onPhoneStepCompleted = () => {    
    dispatchDetailsSteps({type:'UPDATE_MOBILE_STEP', value: true});
    
    if (props.neededInfo.includes('password')) {
      handleSelect('2');
    } else if (!props.neededInfo.includes('password')) {
        handleSelect('');
    }
  };

  const onPasswordStepCompleted = () => {    
    dispatchDetailsSteps({type:'UPDATE_PASSWORD_STEP', value: true});    
    handleSelect('');
  };

  const onContactStepCompleted = () => {        
    dispatchDetailsSteps({type:'UPDATE_CONTACT_STEP', value: true});    
  };

  const contactSectionDisplay = () => {
    if (
      detailsStepsState!.contactStepCompleted ||
      !detailsStepsState!.mailStepCompletetd ||
      !detailsStepsState!.phoneStepCompletetd ||
      !detailsStepsState!.passStepCompletetd
    ) {
      return false;
    } else if (
      !detailsStepsState!.contactStepCompleted &&
      detailsStepsState!.mailStepCompletetd &&
      detailsStepsState!.phoneStepCompletetd &&
      detailsStepsState!.passStepCompletetd
    ) {
      return true;
    }
  };

  
  return (
    <Container fluid>            
      <Row>
        {/* <Col md={1} sm={0} xs={0}></Col> */}
        <Col xl={11} lg={11} md={11} sm={12} xs={12} className='p-5'>
          <div className='x-large dark-blue' role="heading" aria-level={1}>
            {Translate('N_Login_Bio_ID_registration-title_1')}&nbsp;
            <span className='font-weight-bold'>
              {Translate('N_Login_Bio_ID_registration-title_2')}
            </span>
          </div>

          <Accordion
            activeKey={activeKey}             
            className='mt-5'
          >
            <Accordion.Item eventKey="0"
              className={detailsStepsState!.mailStepCompletetd ? 'disabled' : ''}
            >
              <Accordion.Header
                as={Card.Header}
                className={
                  activeKey === '0'
                    ? 'accordion-header-active'
                    : 'accordion-header-inactive'
                }
              >
                <div className='d-flex flex-row align-items-center justify-content-between'>
                  <div
                    role="heading" aria-level={2}
                    className={
                      (_curLang === 'en' || _curLang === 'ru'
                        ? 'flex-row-reverse'
                        : '') + ' d-flex align-items-center'
                    }
                  >
                    {activeKey === '0' ? (
                      <img src={arrowDown} aria-hidden="true" />
                    ) : (
                      <img
                        aria-hidden="true"
                        src={
                          _curLang === 'en' || _curLang === 'ru'
                            ? arrowRight
                            : arrowLeft
                        }                        
                      />
                    )}
                    <span
                      className={
                        activeKey === '0'
                          ? 'medium font-weight-500'
                          : 'medium'
                      }
                    >
                      {Translate('N_Login_app_email_address')}
                    </span>
                  </div>
                  {detailsStepsState!.mailStepCompletetd && (
                    <div className='enabled'>
                      <img src={checkmark} aria-hidden="true" />
                    </div>
                  )}
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <Card.Body>
                  <BIDDetailsMail                    
                    currentState={props.currentState}
                    mailStepCompleted={onMailStepCompleted}
                  />
                </Card.Body>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1"
              className={detailsStepsState!.phoneStepCompletetd ? 'disabled' : ''}
            >
              <Accordion.Header
                as={Card.Header}
                className={
                  activeKey === '1'
                    ? 'accordion-header-active'
                    : 'accordion-header-inactive'
                }
              >
                <div className='d-flex flex-row align-items-center justify-content-between'>
                  <div
                    role="heading" aria-level={2}
                    className={
                      (_curLang === 'en' || _curLang === 'ru'
                        ? 'flex-row-reverse'
                        : '') + ' d-flex align-items-center'
                    }
                  >
                    {activeKey === '1' ? (
                      <img src={arrowDown}  aria-hidden="true"/>
                    ) : (
                      <img
                        aria-hidden="true"
                        src={
                          _curLang === 'en' || _curLang === 'ru'
                            ? arrowRight
                            : arrowLeft
                        }
                        
                      />
                    )}
                    <span
                      className={
                        activeKey === '1'
                          ? 'medium font-weight-500'
                          : 'medium'
                      }
                    >
                      {Translate('N_Login_app_mobile_num')}
                    </span>
                  </div>
                  {detailsStepsState!.phoneStepCompletetd && (
                    <div>
                      <img src={checkmark}  aria-hidden="true"/>
                    </div>
                  )}
                </div>
              </Accordion.Header>
              <Accordion.Body >
                <Card.Body>
                  <DetailsPhone                    
                    currentState={props.currentState}
                    phoneStepCompleted={onPhoneStepCompleted}
                  />
                </Card.Body>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2"
              className={detailsStepsState!.passStepCompletetd ? 'disabled' : ''}
            >
              <Accordion.Header
                as={Card.Header}
                className={
                  activeKey === '2'
                    ? 'accordion-header-active'
                    : 'accordion-header-inactive'
                }
              >
                <div className='d-flex flex-row align-items-center justify-content-between'>
                  <div
                    role="heading" aria-level={2}
                    className={
                      (_curLang === 'en' || _curLang === 'ru'
                        ? 'flex-row-reverse'
                        : '') + ' d-flex align-items-center'
                    }
                  >
                    {activeKey === '2' ? (
                      <img src={arrowDown} aria-hidden="true" />
                    ) : (
                      <img
                        aria-hidden="true"
                        src={
                          _curLang === 'en' || _curLang === 'ru'
                            ? arrowRight
                            : arrowLeft
                        }
                        
                      />
                    )}
                    <span
                      className={
                        activeKey === '2'
                          ? 'medium font-weight-500'
                          : 'medium'
                      }
                    >
                      {Translate('N_Login_Bio_ID_password_stage_title')}
                    </span>
                  </div>
                  {detailsStepsState!.passStepCompletetd && (
                    <div>
                      <img src={checkmark} aria-hidden="true" />
                    </div>
                  )}
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <Card.Body>
                  <DetailsPassword                    
                    passwordStepCompleted={onPasswordStepCompleted}
                  />
                </Card.Body>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {contactSectionDisplay() && (
            <div className='mt-5'>              
              <DetailsApprove ContactStepCompleted={onContactStepCompleted} />
            </div>
          )}
        </Col>
      </Row>      
    </Container>
  );
};
export default DetailsMain;

